var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ui-confirm',{ref:"confirmDialog",attrs:{"set-footer":""},on:{"confirm":function($event){return _vm.$emit('confirmPageLeave')},"abort":function($event){return _vm.$emit('cancelPageLeave')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }